export function GmtOffset(time: string): string {
    const offset = new Date().getTimezoneOffset() * 60000;
    // Static offset
    const incomingTime = new Date(time).getTime();
    const updatedTime = incomingTime - offset;
    const newDateTime = new Date(updatedTime).toString();
    return newDateTime;
}
